import { ReactNode } from "react";
import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import { device } from "../theme/Breakpoints";
import { Color } from "../theme/Color";
import Heading from "./Heading";

interface Props {
  title: string;
  children?: ReactNode;
}

const StyledFeatureRow = styled(Row)`
  color: ${Color.Grey1};
  margin: 0rem 2rem 4rem 2rem;

  @media ${device.smOnly} {
    margin: 4rem 2rem;
  }

  @media ${device.mdOnly} {
    margin: 4rem 2rem;
  }

  @media ${device.lgAndWider} {
    margin: 4rem 0rem;
  }
`;

const FeatureRow = ({ title, children }: Props) => {
  return (
    <StyledFeatureRow>
      <Col xs={12}>
        <Heading fontColor={Color.Grey1} size={3}>
          {title}
        </Heading>
        {children}
      </Col>
    </StyledFeatureRow>
  );
};

export default FeatureRow;
